import {StateCreator} from 'zustand'
import {ActionBoxData} from '../../core/UIGameActionBox/UIGameActionBoxContainer'

export interface GameActionBoxSlice {
    actionBox: {
        actionBoxData: ActionBoxData | undefined
        setActionBoxData: (data: ActionBoxData | undefined) => void
        hideActionBox: () => void
    }
}

export const createGameActionBoxSlice = (): StateCreator<GameActionBoxSlice> => (set, get) => ({
    actionBox: {
        actionBoxData: undefined,
        setActionBoxData: (data) => set({actionBox: {
            ...get().actionBox,
            actionBoxData: data,
        }}),
        hideActionBox: () => set({actionBox: {
            ...get().actionBox,
            actionBoxData: undefined,
        }}),
    },
})
